import { TextField as MUITextField, TextFieldProps } from '@mui/material'
import React from 'react'
import { debounce } from 'util/util'

export interface ITextFieldProps {
  debounced?: boolean,
  delay?:     number,
}

export const TextField = (props: ITextFieldProps & TextFieldProps): JSX.Element => {
  const { delay, debounced, onChange } = props;
  const debouncedChange = debounced ? 
    React.useCallback(debounce(onChange || (() => {}), delay), [onChange])
    : onChange;

  const [text, setText] = React.useState<string>(props.value as string);
  React.useEffect(() => {
    setText(props.value as string);
  }, [props.value]);

  return (
    <MUITextField
      {...Object.assign({}, props, { delay: undefined, debounced: undefined })}
      value    = {text}
      onChange = {(e) => {
        setText(e.target.value);
        debouncedChange && debouncedChange(e);
      }}
    />
  );
}
